import * as React from 'react';
import { useCallback, useMemo } from 'react';

import type { ReportSummary } from 'report/types';
import ReportActions from 'report/reports-page/ReportActions';
import type { SearchParams } from 'stores/PaginationTypes';
import fetchReports from 'report/reports-page/fetchReports';
import ReportQueryHelper from 'report/reports-page/ReportQueryHelper';
import PaginatedEntityTable from 'components/common/PaginatedEntityTable';
import usePluggableEntityTableElements from 'hooks/usePluggableEntityTableElements';

import customColumnRenderers from './ColumnRenderers';

import { getReportTableElements } from '../Constants';

const KEY_PREFIX = ['reports', 'overview'];
const keyFn = (searchParams: SearchParams) => [...KEY_PREFIX, searchParams];

const ReportsList = () => {
  const entityActions = useCallback((listItem: ReportSummary) => <ReportActions report={listItem} />, []);
  const { pluggableColumnRenderers, pluggableAttributes, pluggableExpandedSections } =
    usePluggableEntityTableElements<ReportSummary>(null, 'report');

  const { columnsOrder, tableLayout, fetchOptions, additionalAttributes } = getReportTableElements(pluggableAttributes);
  const columnRenderers = useMemo(() => customColumnRenderers(pluggableColumnRenderers), [pluggableColumnRenderers]);
  const expandedSections = useMemo(
    () => ({
      ...pluggableExpandedSections,
    }),
    [pluggableExpandedSections],
  );

  return (
    <PaginatedEntityTable<ReportSummary>
      humanName="reports"
      columnsOrder={columnsOrder}
      additionalAttributes={additionalAttributes}
      queryHelpComponent={<ReportQueryHelper />}
      entityActions={entityActions}
      entityAttributesAreCamelCase={false}
      tableLayout={tableLayout}
      fetchEntities={fetchReports}
      fetchOptions={fetchOptions}
      keyFn={keyFn}
      expandedSectionsRenderer={expandedSections}
      columnRenderers={columnRenderers}
    />
  );
};

export default ReportsList;
